import { FieldGlobalAttributes } from '@ardoq/api-types';
import { isTruthy } from '@ardoq/common-helpers';
import { uniqBy } from 'lodash';
import { FormattingGroup } from '../types';
import { SelectOptionWithDescription, toOption } from './utils';
import { getCustomFieldsFormattingGroupIfAnyFieldIsAvailableOrNull } from './getCustomFieldsFormattingGroup';
import { DEFAULT_FORMATTING_GROUP_LABEL } from '../../../consts';
import {
  REFERENCE_BUILT_IN_FIELD_DEFS,
  toBuiltInFieldFormatting,
} from '../utils';
import { Locale } from '@ardoq/locale';
import type { I18nLocale } from '@ardoq/i18n';

type Options = {
  i18nLocale: I18nLocale;
  relatedFields: FieldGlobalAttributes[];
  referenceTypeNames: string[];
  isNewConditionalFormatting: boolean;
  locale: Locale;
};

const getDefaultFieldsFormattingGroup = (
  i18nLocale: I18nLocale,
  referenceTypeOptions: SelectOptionWithDescription[]
): FormattingGroup => {
  return {
    label: DEFAULT_FORMATTING_GROUP_LABEL,
    filters: REFERENCE_BUILT_IN_FIELD_DEFS.map(def =>
      toBuiltInFieldFormatting(
        def,
        def.label(i18nLocale, false),
        referenceTypeOptions
      )
    ),
  };
};

export const composeReferencesFormattingGroups = ({
  i18nLocale,
  relatedFields,
  referenceTypeNames,
  isNewConditionalFormatting,
  locale,
}: Options): FormattingGroup[] => {
  const referenceTypeOptions = uniqBy(
    referenceTypeNames.map(name => toOption(name)),
    'value'
  );

  const defaultFieldsFormattingGroup = getDefaultFieldsFormattingGroup(
    i18nLocale,
    referenceTypeOptions
  );
  const customFieldsFormattingGroup =
    getCustomFieldsFormattingGroupIfAnyFieldIsAvailableOrNull(
      relatedFields,
      isNewConditionalFormatting,
      locale
    );

  return [defaultFieldsFormattingGroup, customFieldsFormattingGroup].filter(
    isTruthy
  );
};
